/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-26 17:30:33
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-29 11:20:07
 */
import auth from './auth';
import Bus from './bus.js';
import Msg from './msg.js';
import { install } from '@rd/rd-ui';
import request from '@/utils/request';
import dataMapNew from '@/utils/newDataMap';
import * as types from '@/store/mutation-types.js';
export default {
	install(Vue) {
		// 认证对象
		Vue.prototype.$auth = auth;
		Vue.prototype.$Bus = Bus;
		Vue.prototype.$modal = Msg;
		Vue.prototype.$backTop = () => {
			setTimeout(() => {
				const main = document.querySelector('main.el-main');
				main.scrollTop = 0;
			});
		};

		Vue.prototype.isNotEmpty = val => !['', void 0, null, 'null'].includes(val);
		Vue.prototype.getPlatformName = platformId => {
			return dataMap.PLATFORM_ALL_OBJ[+platformId].label;
		};

		Vue.prototype.$isDy = function (platform_id = this.platformId) {
			return +platform_id === +dataMap.PLATFORM_DY.value;
		};
		Vue.prototype.$isKs = function (platform_id = this.platformId) {
			return +platform_id === +dataMap.PLATFORM_KS.value;
		};
		Vue.prototype.$isSp = function (platform_id = this.platformId) {
			return +platform_id === +dataMap.PLATFORM_SP.value;
		};
		Vue.prototype.$isXhs = function (platform_id = this.platformId) {
			return +platform_id === +dataMap.PLATFORM_XHS.value;
		};
		Vue.prototype.$isAllPF = function (platform_id = this.platformId) {
			return +platform_id === +dataMap.PLATFORM_ALL.value;
		};
		Vue.prototype.$isPlatOr = function (platform_id = this.platformId, platformList) {
			if (utils.checkIsType(platform_id, 'array')) {
				platformList = platform_id;
				platform_id = this.platformId;
			}
			return platformList.some(type => +platform_id === +dataMap[`PLATFORM_${type?.toUpperCase()}`].value);
		};
		Vue.prototype.$copy = function (value, feedbckText = '复制成功') {
			utils.copy(value);
			this.$message.success(feedbckText);
		};
		Vue.prototype.$drName = dataMap.drRoleType.name;
		Vue.prototype.TooltipOpenDelay = 300;
		Vue.prototype.rdTheme = 'blue';
		Vue.prototype.platformId = undefined;
		Vue.prototype.$copy = function (value, feedbckText = '复制成功') {
			utils.copy(value);
			this.$message.success(feedbckText);
		};

		install(
			Vue,
			request,
			{
				...dataMapNew,
				public: dataMap,
				api: {
					addVideoNo: '/api/team-anchor/add-video-no',
				},
				src: {
					emptyBg: 'https://cdn.chaoyongbushou.com/wx/20240725/1721902469451-empty-img@3x.png',
					yxAvatar: 'https://cdn.chaoyongbushou.com/wx/20240815/1723688035746-avatar.png',
				},
			},
			types,
		);
	},
};
